// extracted by mini-css-extract-plugin
export var box404 = "pages-module--box404--62e8c";
export var button404 = "pages-module--button404--afb57";
export var buttonAlign = "pages-module--buttonAlign--90e10";
export var centered = "pages-module--centered--ecd79";
export var grid2columns = "pages-module--grid2columns--5d59c";
export var grid321columns = "pages-module--grid321columns--59a71";
export var grid3columns = "pages-module--grid3columns--46cb5";
export var gridWrapper = "pages-module--gridWrapper--77762";
export var mediaCard = "pages-module--mediaCard--5f17d";
export var sellingPoints = "pages-module--sellingPoints--b6f4e";
export var separator = "pages-module--separator--b4161";
export var subTitle = "pages-module--subTitle--e3e0c";
export var subTitleResources = "pages-module--subTitleResources--dcbf0";
export var subtitle404 = "pages-module--subtitle404--4c950";
export var title404 = "pages-module--title404--2ff17";
export var videoCard = "pages-module--videoCard--a28de";
export var whiteBox = "pages-module--whiteBox--63357";